module.exports = __webpack_public_path__ + "img/icon1.21ba13d6.png";